var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"mb-5 mt-5"}),_vm._v(" "),_vm._t("banner"),_vm._v(" "),_c('main',{staticClass:"container mb-5 mt-5"},[_vm._t("default")],2),_vm._v(" "),_vm._t("footer")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-304c7e6c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/BaseLayout.vue
// module id = null
// module chunks = 